export enum ProgressItemEnum {
  CALENDAR = 1,
  MEETING = 2,
  MEETING_REPORT = 4,
  INTEGRATION = 8,
}

export interface ProgressItemConfig {
  name: string;
  description: string;
  type: ProgressItemEnum;
  pathname: string;
}

export interface ProgressItem extends ProgressItemConfig {
  completed: boolean;
}

export interface ProgressItemState {
  type: ProgressItemEnum;
  state: "todo" | "unmarked_complete" | "complete";
}
